// Steadfast Styles - Main Entry Point
// Single source of truth for design tokens, themes, and utilities

// Export theme utilities and providers
export { ThemeProvider, useTheme } from './themes';
export { applyTheme, toggleTheme, initializeTheme, getResolvedTheme } from './themes';
export type { ThemeMode } from './themes';

// Export Tailwind config
export { default as tailwindConfig } from './tailwind/config';

// SCSS is available for direct imports:
// @use '@sandeep12.patil/sf-styles/scss' for tokens, variables, and themes
// @use '@sandeep12.patil/sf-styles/scss/tokens' for SCSS variables only
// @use '@sandeep12.patil/sf-styles/scss/themes' for theme CSS variables
